import { Handle, Position } from "@xyflow/react";
import React, { useState } from "react";
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import {
  addBranchToStep,
  updateAndThenInfo,
} from "../../../services/CollectionsSvc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCheck } from "@fortawesome/free-solid-svg-icons";
import AddEditSignUpModal from "./AddEditSignUpModal";

const ViewSignUpBox = ({
  data,
  onNewStep,
  totalSteps,
  onDelete,
  steps = [],
  hasVotes,
  onEditContent,
  selNetworkId,
}) => {
  const { part, branchOption, branches, andThen } = data || [];
  const form = part?.signupForm || {};
  const [selectedOption, setSelectedOption] = useState(andThen || null);
  const [showSignUpModal, setShowSignUpModal] = useState(false);

  const handleSelectOption = async (selectedStepId) => {
    if (selectedStepId === "end") {
      setSelectedOption(null);
      try {
        if (andThen) {
          await updateAndThenInfo(data.id, 0);
        }
      } catch (error) {
        console.error("Failed to save the selected option:", error);
      }
    } else {
      const nextStep = steps.find(
        (step) => step.id === parseInt(selectedStepId, 10)
      );
      if (nextStep) {
        const nextStepOrder = nextStep.order;
        setSelectedOption({ nextStepId: nextStep.id, nextStepOrder });

        try {
          if (andThen) {
            await updateAndThenInfo(data.id, nextStep.id);
          } else {
            await addBranchToStep(data.id, {
              branchOption: null,
              nextStepId: nextStep.id,
            });
          }
        } catch (error) {
          console.error("Failed to save the selected option:", error);
        }
      } else {
        console.error("Next step not found");
      }
    }
  };

  const titleStyle = {
    color: form?.styleTitle?.color || "#333333",
    fontSize: form?.styleTitle?.fontSize || "24px",
  };
  const descriptionStyle = {
    color: form?.styleDescription?.color || "#333333",
    fontSize: form?.styleDescription?.fontSize || "16px",
  };
  const buttonStyle = {
    fontSize: form?.styleButton?.fontSize || "16px",
    color: form?.styleButton?.textColor || "#333333",
  };

  return (
    <div
      className={
        !branchOption && data?.stepIndex + 1 === totalSteps
          ? "last-step view-poll-box"
          : "view-poll-box"
      }
    >
      <Handle type="target" position={Position.Top} id="top-handle" />
      <Handle type="target" position={Position.Left} id="left-handle" />

      <div
        style={{
          marginRight: "0px",
          backgroundColor: "transparent",
          display: "flex",
          gap: "50px",
        }}
        key={form.id}
      >
        <div style={{ width: "350px" }}>
          {branchOption ? (
            <>
              <div className="user-option-selected-container">
                {/* <div className="user-option-header">If user select</div> */}
                <div className="user-option-header">&nbsp;</div>
                <span
                  className="remove-button"
                  onClick={() => onDelete(data.branchId, "branch")}
                >
                  Remove
                </span>
              </div>
              {/* <div className="option-container">{branchOption}11111111</div> */}
            </>
          ) : (
            <div className="step-number">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">Step {data.order}</span>
                <div style={{ display: "flex", gap: "8px" }}>
                  <span
                    className="customLabel remove-button"
                    onClick={() => setShowSignUpModal(true)}
                  >
                    Edit
                  </span>
                  <span
                    className="customLabel remove-button"
                    onClick={() => onDelete(data.id, "step")}
                  >
                    Remove
                  </span>
                </div>
              </div>
            </div>
          )}
          <div className="form-box">
            <div className="form-box-title" style={titleStyle}>
              {form.title}
            </div>
            <div className="form-box-description" style={descriptionStyle}>
              {form.description}
            </div>
            <div style={{ textAlign: "center" }}>
              <FontAwesomeIcon
                icon={faUserCheck}
                style={{
                  color: "#625d5dff",
                  fontSize: "72px",
                  marginBottom: "10px",
                }}
              />
            </div>
            <button
              disabled
              className="form-box-submit blue-button"
              style={buttonStyle}
            >
              {form.buttonText || "Sign Up"}
            </button>

            <div className="form-box-terms">
              This will open a sign up form at the time of rendering.
            </div>
          </div>
          {branchOption &&
            branches?.length === 0 &&
            data?.stepIndex + 1 !== totalSteps && (
              <>
                <div className="user-option-selected-container option-container mt-2">
                  <div className="">And then</div>
                  <DropdownButton
                    id="and-then-dropdown"
                    size="md"
                    variant="outline-secondary"
                    title={
                      selectedOption
                        ? selectedOption.nextStepOrder <=
                          data.rootStep.stepOrder
                          ? `Return to Step ${selectedOption.nextStepOrder}`
                          : `Jump to Step ${selectedOption.nextStepOrder}`
                        : "End Sequence"
                    }
                    onSelect={handleSelectOption}
                    disabled={hasVotes}
                  >
                    {steps
                      .filter((step) => step.id !== data.id)
                      .map((step) => (
                        <Dropdown.Item
                          key={step.id}
                          eventKey={step.id.toString()}
                        >
                          Step {step.order}
                        </Dropdown.Item>
                      ))}
                    <Dropdown.Item eventKey="end">End Sequence</Dropdown.Item>
                  </DropdownButton>
                </div>
              </>
            )}
        </div>
        {!branchOption && data?.stepIndex + 1 === totalSteps && (
          <div>
            <div className="add-step-button-container">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">
                  Add Step {data.order + 1}
                </span>
              </div>
            </div>
            <div className="add-step-branch-group">
              <div className="d-flex justify-content-center border align-items-center add-step-container">
                <Button
                  onClick={() => onNewStep(data)}
                  className="add-step-button"
                >
                  +
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} id="bottom-handle" />
      <Handle type="source" position={Position.Right} id="right-handle" />
      {showSignUpModal && (
        <AddEditSignUpModal
          show={showSignUpModal}
          onClose={(nextIdOrTrue) => {
            setShowSignUpModal(false);
            if (onEditContent) onEditContent(true);
          }}
          contentFormId={form?.id}
          selNetworkId={selNetworkId}
          sequenceId={data.sequenceId}
          orderNumber={data.order}
        />
      )}
    </div>
  );
};

export default ViewSignUpBox;
